import { addDays, setHours, setMinutes, startOfWeek } from "date-fns";
import { parseExternalServiceCodeType } from "types/externalService";
import { ScheduleItem } from "types/response/schedule";
import { CLEANING_SETTING_TYPES, getCleaningSettingFields } from "utils/robot/cleaningSetting/cleaningSetting";

export const dayMap: Record<string, string> = {
  "0": "日",
  "1": "月",
  "2": "火",
  "3": "水",
  "4": "木",
  "5": "金",
  "6": "土",
};

/**
 * スケジュールを実行時間順に並び替え。日曜基点
 */
export const getThisWeekRuns = (schedules: ScheduleItem[]) => {
  const runs: { datetime: Date; schedule: ScheduleItem }[] = [];

  const start = startOfWeek(new Date(), { weekStartsOn: 0 }); // 0: 日曜

  for (let offset = 0; offset < 7; offset++) {
    const date = addDays(start, offset);
    const day = date.getDay();

    for (const schedule of schedules) {
      if (schedule.dayOfWeek === day) {
        const datetime = setMinutes(
          setHours(date, schedule.hour),
          schedule.minute
        );
        runs.push({ datetime, schedule });
      }
    }
  }

  return runs.sort((a, b) => a.datetime.getTime() - b.datetime.getTime());
};

type DisplayLabel = {
  type: string;
  value: string;
  hide?: boolean;
};
const invalidLabel: DisplayLabel = { type: "不明", value: "-" };

/**
 * 清掃設定の type, value の表示用ラベルを取得する
 */
export const getCleaningSettingDisplayLabels = ({
  code,
  settings,
}: {
  code: string;
  settings: {
    type: string;
    value: string;
  }[];
}): DisplayLabel[] => {
  const parsedExCode = parseExternalServiceCodeType(code);
  if (!parsedExCode) {
    console.log({ msg: "invalid exSrvCode", code });
    return [invalidLabel];
  }

  const cleanType = settings.find(
    (s) => s.type === CLEANING_SETTING_TYPES.cleanType
  )?.value;

  const fields = getCleaningSettingFields(parsedExCode, {
    cleanType,
  });

  return settings.map((s) => {
    const field = fields.find((f) => f.type === s.type);
    if (!field) return invalidLabel;
    const valueLabel = field.options.find(
      (opt) => opt.value === s.value
    )?.label;
    if (!valueLabel) return invalidLabel;
    return { type: field.typeLabel, value: valueLabel, hide: field.hide };
  });
};

type ScheduleKey = {
  dayOfWeek: number;
  hour: number;
  minute: number;
};
/**
 * 指定したスケジュールが既にリストに存在するか判定する
 */
export const alreadyExists = (
  candidate: ScheduleKey,
  list: ScheduleKey[]
): boolean => {
  return list.some(
    (s) =>
      s.dayOfWeek === candidate.dayOfWeek &&
      s.hour === candidate.hour &&
      s.minute === candidate.minute
  );
};
